import LearnSourceGroupService from '@/services/LearnSourceGroupService'

const createLearnSourceGroupsModule = () => ({
  namespaced: true,
  state: {
    page: 1,
    pages: 1,
    pageSize: 15,
    total: 0,
    learnSourceGroups: []
  },
  actions: {
    getLearnSourceGroups: ({ commit, state }) => {
      LearnSourceGroupService.getLearnSourceGroups(state.pageSize, state.page)
        .then((data) => {
          commit('SET_LEARN_SOURCE_GROUPS', {
            learnSourceGroups: data.learnSourceGroups
          })
          commit('SET_PAGES', { pages: data.pages })
          commit('SET_TOTAL', { total: data.total })
        })
        .catch((err) => {
          console.info(err)
        })
    },
    setPage: ({ dispatch, commit, state }, page) => {
      commit('SET_PAGE', { page })
      dispatch('getLearnSourceGroups')
    }
  },
  getters: {
    prevDisabled: (state) => state.page === 1,
    nextDisabled(state) {
      return state.pageSize * state.page >= state.total
    }
  },
  mutations: {
    SET_LEARN_SOURCE_GROUPS: (state, { learnSourceGroups }) => {
      state.learnSourceGroups = learnSourceGroups
    },
    SET_PAGES: (state, { pages }) => {
      state.pages = pages
    },
    SET_PAGE: (state, { page }) => {
      state.page = page
    },
    SET_TOTAL: (state, { total }) => {
      state.total = total
    }
  }
})

export default createLearnSourceGroupsModule
